<template>
  <div class="zj-layout-main-content bgcolor scrollable">
  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="16rem">
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">待处理求助</div>
      </zj-layout-header>
    </zj-layout-container>
    <el-form-item label="报警渠道"  style="width:280px;display: inline-block;">
      电话上报
      <!-- <el-input v-model="ruleForm.title"  style="width:118rem;" v-bind:disabled="IsEdit"></el-input> -->
    </el-form-item>
     <el-form-item label="报警时间"  style="display: inline-block;">
      2020-07-01 13:00:09
    </el-form-item>
    <el-form-item label="求助地点"  >
      中华大街
    </el-form-item>
    <el-form-item label="详细地址"  >
      门口永辉超市
    </el-form-item>
    <el-form-item label="求助人"  >
      张三
    </el-form-item>
    <el-form-item label="求助人联系电话"  >
      13439849821
    </el-form-item>
    <el-form-item label="求助人内容描述"  >
     爱很简单好地方卡德加富士康的
    </el-form-item>
    <el-form-item label="是否受理" prop="treatmentMethod">
      <el-radio-group v-model="ruleForm.treatmentMethod">
        <el-radio label="转为应急事件"></el-radio>
         <el-radio label="正常受理"></el-radio>
         <el-radio label="不予受理（虚报）"></el-radio>
      </el-radio-group>
    </el-form-item>
     <el-form-item label="受理日期" >
      2020-07-01 13:00:09
    </el-form-item>
    <el-form-item label="确认事件类型" prop="eventType">
      <el-radio-group v-model="ruleForm.eventType">
        <el-radio label="伤员求助"></el-radio>
         <el-radio label="暴雨求助"></el-radio>
         <el-radio label="其他"></el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="结案说明" prop="desc" style="width:80rem;">
      <el-input type="textarea" v-model="ruleForm.desc"></el-input>
    </el-form-item>
    <el-form-item class="right" style="width:134rem;">
      <el-button @click="onBack()">返回</el-button>
      <el-button type="primary" @click="submitForm('ruleForm')" v-show="IsEdit==false">保存</el-button>
    </el-form-item>
  </el-form>
 </div>
</template>
<script>
import MyApis from "../../../apis";
export default {
  name: "ClosingForHelpInfo",
  controller: "UI",
  action: "ClosingForHelpInfo",
  data() {
    return {
      ruleForm:{
              eventType:"",
              treatmentMethod:"",
              desc:""
            },
      rules: {
        treatmentMethod:[
          { required: true, message: '请选择处理方式', trigger: 'change' }
        ],
        eventType:[
          { required: true, message: '请选择初判事件类型', trigger: 'change' }
        ],
        desc:[
          { required: true, message: '请填写结案说明', trigger: 'change' }
        ]
      },
      IsEdit: false
      // dialogImageUrl: '',
      // dialogVisible: false,
      // disabled: false
    };
  },
  created: function() {
    this.ruleForm.checkList=[];
    this.basedatabind();
    this.search();
    this.IsEdit = this.query.type == "edit" ? false : true;
  },
  mounted: function() {},
  watch: {
    query: {
      // handler: function(val, oldVal) {
      //   this.ruleForm = {
      //     ResourceName: "",
      //         TranresourcesType: "",
      //         StorageAddress: "",
      //         Longitude: "",
      //         Latitude: "",
      //         Contact: "",
      //         Phone: "",
      //         Quantity: "0",
      //         Remark: ""
      //   };
      //   this.search();
      // },
      // immediate: true,
      // deep: true
    },
    // checkList:{
    //   handler:function(newVal){
    //     this.ruleForm.checkList=newVal;
    //     console.log(newVal)
    //     console.log(this.ruleForm.checkList)
    //   },
    //   immediate:true
    // }
  },
  methods: {
     handleRemove(file) {
        console.log(file);
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      uploadAvatar(item) {
        console.log(item)
      },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    //基础数据绑定
    basedatabind() {
      //所属应急组织类型
      this.config
        .getUValue("EmergencyService:TranresourcesType:", "")
        .then(d => {
          this.options = d.JValue;
        })
        .catch(e => console.error(e));
    },
    search() {
      let ResourcesId = this.query.obj;
      if (ResourcesId != null && ResourcesId != "") {
        let searchInfo = {
          ResourcesId: ResourcesId,
          PageSize: 20,
          PageIndex: 1,
          TotalCount: 0,
          StartNumber: 0,
          EndNumber: 0
        };
        new MyApis.TranResourcesApi()
          .GetItemById(searchInfo)
          .then(r => {
            r = r.data.Data;
            //console.log(r);
            this.ruleForm = r;
          })
          .catch(e => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    onGotLngLat(obj) {
      this.ruleForm.Latitude = obj.lat;
      this.ruleForm.Longitude = obj.lng;
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //重置
    resetForm(formName) {
      this.ruleForm = formName;
      //this.$refs[formName].resetFields();
      // this.query.obj = null;
    },
    save() {
      console.log(this.checkList)
      
      // this.ruleForm.Quantity = parseFloat(this.ruleForm.Quantity);
      // this.ruleForm.Longitude = parseFloat(this.ruleForm.Longitude);
      // this.ruleForm.Latitude = parseFloat(this.ruleForm.Latitude);
      // if (this.query.obj == null||this.query.obj == "") {
      //   new MyApis.TranResourcesApi()
      //     .AddItem(this.ruleForm)
      //     .then(r => {
      //       r = r.data.Data;
      //       this.$message({
      //         type: "success",
      //         message: r ? "保存成功！" : "保存失败！"
      //       });
      //       this.$router.go(-1); //返回上一层
      //     })
      //     .catch(e => {
      //       console.log(e);
      //       this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
      //     });
      // } else {
      //   new MyApis.TranResourcesApi()
      //     .UpdateItem(this.ruleForm)
      //     .then(r => {
      //       r = r.data.Data;
      //       this.$message({
      //         type: "success",
      //         message: r ? "保存成功！" : "保存失败！"
      //       });
      //       this.$router.go(-1); //返回上一层
      //     })
      //     .catch(e => {
      //       console.log(e);
      //       this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
      //     });
      // }
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.save();
        } else {
          console.log("error submit!!")
          return false;
        }
      })
      //this.$router.go(-1); //返回上一层
    }
  }
}
</script>